import React from 'react';
import { Button, Chip, TableCell, TableRow } from '@mui/material';
import { InvestorStatementItem } from '../../../models/admin/InvestorStatement';

function formatCurrency(amount: number | null): string {
  if (amount === null) return '—';
  return amount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
}

function statusChipColor(item: InvestorStatementItem): 'success' | 'default' | 'warning' {
  if (item.status === 'CONFIRMED') return 'success';
  if (item.status === 'DISCARDED') return 'default';
  return 'warning';
}

interface StatementReviewRowProps {
  item: InvestorStatementItem;
  busy: boolean;
  onView: (item: InvestorStatementItem) => void;
  onConfirm: (item: InvestorStatementItem) => void;
  onSkip: (item: InvestorStatementItem) => void;
}

/** One row of StatementReviewList's table — the entity's amounts, status, and its actions. */
const StatementReviewRow: React.FC<StatementReviewRowProps> = ({
  item,
  busy,
  onView,
  onConfirm,
  onSkip,
}) => (
  <TableRow>
    <TableCell>{item.investmentEntityName}</TableCell>
    <TableCell>{item.investorName}</TableCell>
    <TableCell align="right">{formatCurrency(item.totalIncoming)}</TableCell>
    <TableCell align="right">{formatCurrency(item.totalOutgoing)}</TableCell>
    <TableCell>
      <Chip
        label={item.emailSentAt ? 'Sent' : item.status}
        size="small"
        color={statusChipColor(item)}
      />
    </TableCell>
    <TableCell align="right">
      <Button size="small" disabled={busy} onClick={() => onView(item)}>
        View
      </Button>
      {item.status === 'STAGED' && (
        <>
          <Button size="small" variant="contained" disabled={busy} onClick={() => onConfirm(item)}>
            Add to Investor Documents
          </Button>
          <Button size="small" color="inherit" disabled={busy} onClick={() => onSkip(item)}>
            Skip
          </Button>
        </>
      )}
    </TableCell>
  </TableRow>
);

export default StatementReviewRow;
